import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { validateIntegerParam } from '@/middleware/validateIntegerParam';
import { PurchaseOrders } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${PurchaseOrders.Pages.PURCHASE_ORDER}`,
    name: PurchaseOrders.Pages.PURCHASE_ORDER,
    component: () => import(/* webpackChunkName: "purchase-orders" */ '@/modules/purchase-orders/views/PurchaseOrders.vue'),
    meta: {
      access_roles: RouteRoles[PurchaseOrders.Pages.PURCHASE_ORDER],
    },
  },
  {
    path: `/${PurchaseOrders.Pages.PURCHASE_ORDER_DETAIL}/:id`,
    name: PurchaseOrders.Pages.PURCHASE_ORDER_DETAIL,
    beforeEnter: validateIntegerParam('id'),
    component: () => import(/* webpackChunkName: "purchase-orders" */ '@/modules/purchase-orders/views/PurchaseOrderDetail.vue'),
    meta: {
      access_roles: RouteRoles[PurchaseOrders.Pages.PURCHASE_ORDER_DETAIL],
    },
  },
];

export default routes;
